import React from "react";
import { Link } from "react-router-dom";
import { EMAIL, LINKEDIN_URL } from "../../lib/booking";
import { EXPERTISES } from "../../data/expertises";
import { CITIES } from "../../data/cities";
import { EXPERTISE_PAGES_ENABLED } from "../../lib/flags";

export const SeoFooter = () => {
    return (
        <footer
            className="relative py-20 md:py-28 border-t border-white/10 bg-[#040404]"
            data-testid="seo-footer"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="bye-fadeup">
                    <div className="text-xs tracking-[0.28em] uppercase text-[#c39d63] mb-6">
                        Brand Your Expertise
                    </div>
                    <h3 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white max-w-4xl leading-[0.95]">
                        Faisons de votre expertise{" "}
                        <span className="italic bye-gold-text">
                            le bruit de fond du marché.
                        </span>
                    </h3>
                </div>

                <div className="bye-divider my-16" />

                <div className={`grid grid-cols-1 ${EXPERTISE_PAGES_ENABLED ? "md:grid-cols-4" : "md:grid-cols-3"} gap-10 text-sm`}>
                    <div>
                        <div className="text-white/40 uppercase tracking-[0.2em] text-xs mb-3">
                            Contact
                        </div>
                        <a
                            href={`mailto:${EMAIL}`}
                            className="text-white/80 hover:text-white block"
                            data-testid="seo-footer-email"
                        >
                            {EMAIL}
                        </a>
                        <a
                            href={LINKEDIN_URL}
                            target="_blank"
                            rel="noreferrer"
                            className="text-white/80 hover:text-white block mt-2"
                        >
                            linkedin.com/in/fabienmoutier
                        </a>
                        <Link
                            to="/"
                            className="text-white/80 hover:text-white block mt-2"
                        >
                            Accueil
                        </Link>
                    </div>

                    {EXPERTISE_PAGES_ENABLED && (
                        <div>
                            <div className="text-white/40 uppercase tracking-[0.2em] text-xs mb-3">
                                Expertises
                            </div>
                            {EXPERTISES.map((e) => (
                                <Link
                                    key={e.slug}
                                    to={`/expertise/${e.slug}`}
                                    className="text-white/70 hover:text-white block mt-1.5"
                                >
                                    {e.navLabel}
                                </Link>
                            ))}
                        </div>
                    )}

                    <div>
                        <div className="text-white/40 uppercase tracking-[0.2em] text-xs mb-3">
                            Villes
                        </div>
                        {CITIES.map((c) => (
                            <Link
                                key={c.slug}
                                to={`/${c.slug}`}
                                className="text-white/70 hover:text-white block mt-1.5"
                            >
                                {c.city}
                            </Link>
                        ))}
                    </div>

                    <div>
                        <div className="text-white/40 uppercase tracking-[0.2em] text-xs mb-3">
                            Studio & crédits
                        </div>
                        <p className="text-white/60 leading-relaxed">
                            Studio loué à Lausanne ou Genève. Écriture &
                            stratégie : Fabien Moutier. Réalisation en
                            collaboration avec des studios et agences
                            partenaires.
                        </p>
                    </div>
                </div>

                <div className="mt-16 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/40">
                    <div>
                        © {new Date().getFullYear()} Brand Your Expertise — Tous
                        droits réservés.
                    </div>
                    <div>Pensé pour les dirigeants. Écrit à la main.</div>
                </div>
            </div>
        </footer>
    );
};
